import { TSilhouetteMarkerModel } from './silhouette-marker.types';

const log = (silhouetteMarkerModel: TSilhouetteMarkerModel): TSilhouetteMarkerModel => {
  console.log('[Log] Silhouette Model', silhouetteMarkerModel);
  return silhouetteMarkerModel;
};

export const SILHOUETTE_MARKER_PIPELINE = {
  computePoints: (silhouetteMarkerModel: TSilhouetteMarkerModel): TSilhouetteMarkerModel => {
    const tasks = [log];
    return tasks.reduce((a, v) => v(a), silhouetteMarkerModel);
  },
};
